// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GtUEn","list-container":"styles_list-container__i81os","text-container":"styles_text-container__eJRvg"};